<template>
  <div class="scroll-img">
    <img
      :src="item"
      alt=""
      v-for="(item, index) in formattedValue"
      :key="item + index"
    />
  </div>
</template>
<script>
import { divideSymbol } from "@/lobby_common/utils/utils.js";
import jp0 from "@/assets/jackpot/jp0.png";
import jp1 from "@/assets/jackpot/jp1.png";
import jp2 from "@/assets/jackpot/jp2.png";
import jp3 from "@/assets/jackpot/jp3.png";
import jp4 from "@/assets/jackpot/jp4.png";
import jp5 from "@/assets/jackpot/jp5.png";
import jp6 from "@/assets/jackpot/jp6.png";
import jp7 from "@/assets/jackpot/jp7.png";
import jp8 from "@/assets/jackpot/jp8.png";
import jp9 from "@/assets/jackpot/jp9.png";
import jpcomma from "@/assets/jackpot/jpcomma.png";
import jpspot from "@/assets/jackpot/jpspot.png";
export default {
  props: {
    finalValue: {
      type: Number,
      default: 100,
    },
    initiaValue: {
      type: Number,
      default: 0,
    },
    decimal: {
      type: Number,
      default: 2,
    },
    showThousand: {
      type: Boolean,
      default: true,
    },
    updateInterval: {
      type: Number,
      default: 1000,
    },
    proportion: {
      type: Number,
      default: 0.0001,
    },
    maxRate: {
      type: Number,
      default: 1.9,
    },
    minRate: {
      type: Number,
      default: 0.1,
    },
  },
  data() {
    return {
      // initiaValue: this.finalValue * 0.8,
      currentValue: 0,
      intervalId: null,
    };
  },
  computed: {
    formattedValue() {
      const formatted = this.currentValue.toFixed(this.decimal);
      const showFormatted = divideSymbol(formatted);
      // console.log("=======", showFormatted);
      const arr = [];
      for (const char of showFormatted) {
        switch (char) {
          case "0":
            arr.push(jp0);
            break;
          case "1":
            arr.push(jp1);
            break;
          case "2":
            arr.push(jp2);
            break;
          case "3":
            arr.push(jp3);
            break;
          case "4":
            arr.push(jp4);
            break;
          case "5":
            arr.push(jp5);
            break;
          case "6":
            arr.push(jp6);
            break;
          case "7":
            arr.push(jp7);
            break;
          case "8":
            arr.push(jp8);
            break;
          case "9":
            arr.push(jp9);
            break;
          case ",":
            arr.push(jpcomma);
            break;
          case ".":
            arr.push(jpspot);
            break;
          default:
        }
      }
      return arr;
    },
  },
  watch: {
    initiaValue: {
      handler(newVal) {
        this.currentValue = newVal;
      },
      immediate: true,
    },
    // finalValue: function(newVal) {
    //     if (this.currentValue === this.initiaValue) {
    //         this.startIncrement();
    //     }
    // }
  },
  mounted() {
    this.startIncrement();
  },
  methods: {
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // const minIncrement = this.finalValue * 0.01;

      this.intervalId = setInterval(() => {
        if (this.finalValue < 1) return;
        if (this.currentValue < this.finalValue * 0.95) {
          const randomIncrement =
            Math.random() * (this.maxRate - this.minRate) + this.minRate;
          const maxIncrement =
            this.finalValue * this.proportion * randomIncrement;
          // const maxIncrement = this.finalValue * this.proportion;
          this.currentValue += maxIncrement;

          if (this.currentValue > this.finalValue * 0.95) {
            this.currentValue = this.finalValue * 0.8;
          }
        } else {
          this.currentValue = this.finalValue * 0.8;
        }
      }, this.updateInterval);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
<style lang="scss" scoped>
.scroll-img {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    // width: 30px;
    height: 40px;
    margin-right: 3px;
    @media (max-width: 768px) {
      height: 33px;
    }
  }
}
</style>
